export function isNotEqual(value: any, target: any): Error | undefined {
    if (value === target) {
      return new Error(`Value should not be "${target}"`);
    }
}